import React, { useMemo } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import '../alert-form.css';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { selectNameAlertData } from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import { selectRoomAlertDeviceList, selectSensorMap } from '../../../../redux/slices/deviceList/deviceListSlice';
import { getChannelDisplayData } from '../../../../utility/channelUtils';
import { selectTagList } from '../../../../redux/slices/tagListSlice/tagListSlice';

function asArray(value) {
  return Array.isArray(value) ? value : [];
}
function DefineActionsSummary({ onEdit = null }) {
  const nameAlertData = useSelector(selectNameAlertData);
  const deviceList = useSelector(selectRoomAlertDeviceList);
  const sensorMap = useSelector(selectSensorMap);
  const alertTags = nameAlertData && nameAlertData.alertTags;
  const tagList = useSelector(selectTagList);

  const resolvedTagNames = useMemo(() => {
    const tags = asArray(alertTags);
    return tags
      .map((tag) => {
        // Extract the ID (handle both {id} objects and raw IDs)
        const tagId = tag && typeof tag === 'object' ? tag.id : tag;
        // Look up the full tag in tagList
        const fullTag = tagList.find((t) => t.id === tagId);
        return fullTag ? fullTag.name : null;
      })
      .filter(Boolean);
  }, [alertTags, tagList]);

  const tagsText = resolvedTagNames.length ? resolvedTagNames.join(', ') : 'None';
  const showTags = alertTags && typeof alertTags.size === 'function'
    ? alertTags.size() > 0
    : resolvedTagNames.length > 0;
  const additionalSensors = nameAlertData && nameAlertData.additionalSensors;
  const renderFormattedAdditionalSensors = () => additionalSensors
    .map((sensorChannel, index) => {
      const {
        key,
        deviceName,
        sensorName,
        port,
        channelName,
      } = getChannelDisplayData(sensorChannel, deviceList, sensorMap);

      return (
        <React.Fragment key={key}>
          {`${deviceName} > `}
          <strong>{sensorName}</strong>
          {` (${port}) > ${channelName}`}
          {index < additionalSensors.length - 1 && ', '}
        </React.Fragment>
      );
    });

  return (
    <Card className="alert-card">
      <Card.Body>
        <>
          <Row className="align-items-center">
            <Col>
              <Card.Title className="mb-0">Details:</Card.Title>
            </Col>
            <Col className="text-right">
              {/* eslint-disable-next-line react/button-has-type */}
              {
                onEdit && (
                <FontAwesomeIcon
                  className="btn btn-link"
                  onClick={onEdit}
                  icon={faPencil}
                >
                  Edit
                </FontAwesomeIcon>
                )
              }
            </Col>
          </Row>
          <Row>
            <Col>
              Alert Name:
            </Col>
            <Col>
              <strong>
                {nameAlertData.alertNameInput}
              </strong>
            </Col>
          </Row>
          {showTags && (
          <Row>
            <Col>Tags:</Col>
            <Col><strong>{tagsText}</strong></Col>
          </Row>
          )}
          <Row>
            <Col>Timezone:</Col>
            <Col>{nameAlertData.timeZoneName}</Col>
          </Row>
          <Row>
            <Col>Additional Sensors:</Col>
            <Col>
              {renderFormattedAdditionalSensors()}
            </Col>
          </Row>
        </>
      </Card.Body>
    </Card>
  );
}
DefineActionsSummary.defaultProps = {
  onEdit: null,
};
DefineActionsSummary.propTypes = {
  onEdit: PropTypes.func,
};
export default DefineActionsSummary;
